import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('workspace', [
      'activeService',
      'activeServiceId',
      'serviceCountdownRemaining',
      'serviceSessionRunning',
    ]),
    usesService() {
      return this.config.useService !== false && !!this.activeService
    },
  },
  methods: {
    ...mapActions('workspace', [
      'startServiceCountdown',
      'pauseServiceCountdown',
      'resetServiceCountdown',
      'toggleServiceCountdown',
    ]),
  },
}
